module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/p7jg8TiT0Cz12BlA2Encq-67b31bd4d32b7b000463e055a8c44a37.jpg";